/**
 * Created by Rodrigo Quesada on 14/03/17.
 */
import {Component, forwardRef, HostListener, Input, OnDestroy} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {noop} from '../../../../common/functions/functions.util';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {SignatureModalComponent} from './signature-modal.component';
import {ClientInfoService} from '../../../../domain/model/info/client/client-info.service';
import moment = require('moment');
import Moment = moment.Moment;

//region Other Classes
export class SignatureInfoModel {
    constructor(public data: string, public date: Moment, public ip: string) {}
}

//endregion

export const SIGNATURE_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SignatureInputComponent),
    multi: true
};

let nextUniqueId = 0;

/**
 * Component that represents a text input. It encapsulates the <input> HTMLElement and
 * improve on its behaviour, along with styling it according to the Material Design.
 */
@Component({
    selector: 'my-signature-input',
    template: require('./signature-input.component.html'),
    styles: [require('./signature-input.component.scss')],
    providers: [SIGNATURE_INPUT_CONTROL_VALUE_ACCESSOR],
    host: {'(click)': 'focus()'}
})
export class SignatureInputComponent implements ControlValueAccessor, OnDestroy {

    private _modalRef: NgbModalRef;

    //region Input
    @Input() id: string = `my-signature-input-${nextUniqueId++}`;
    @Input() placeholder: string | null = null;
    @Input() name: string | null = null;

    @Input() errorMessage: string;
    @Input() errorMessagePosition: string = 'right';
    //endregion

    //region HostListener
    @HostListener('click', ['$event'])
    handleClickEvent(event: Event) {
        this._modalRef = this._modalService.open(SignatureModalComponent, {
            backdrop: 'static',
            size: 'lg',
            keyboard: false
        });
        if (this.value) this._modalRef.componentInstance.data = this.value.data;

        this._modalRef.result.then(data => {
            if (data) this._clientInfoService.getIp().subscribe(ip =>
                this.value = new SignatureInfoModel(data, moment(), ip)
            );
            else this.value = undefined;
        }, _ => {});
    }

    //endregion

    get inputId(): string { return `${this.id}-input`; }

    get empty() { return this._value == null || this._value.data === ''; }

    private _value;

    get value(): SignatureInfoModel | undefined { return this._value; };

    @Input()
    set value(v: SignatureInfoModel | undefined) {
        if (v !== this._value) {
            this._value = v;
            this._onChangeCallback(v);
        }
    }

    constructor(private readonly _modalService: NgbModal,
                private readonly _clientInfoService: ClientInfoService) {
    }

    ngOnDestroy() {
        if (this._modalRef) {
            this._modalRef.close();
        }
    }

    _hasPlaceholder(): boolean { return !!this.placeholder; }

    //region ControlValueAccessor
    /** Callback registered via registerOnTouched (ControlValueAccessor) */
    private _onTouchedCallback: () => void = noop;
    /** Callback registered via registerOnChange (ControlValueAccessor) */
    private _onChangeCallback: (_: any) => void = noop;

    writeValue(value: SignatureInfoModel | undefined): void { this._value = value; }

    registerOnChange(fn: any): void { this._onChangeCallback = fn; }

    registerOnTouched(fn: any): void { this._onTouchedCallback = fn; }

    //endregion
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/signature/signature-input.component.ts